/**
 * Utility function to compare Last-Modified header values
 * @param currentValue - The current Last-Modified header value
 * @param previousValue - The previous Last-Modified header value
 * @returns True if the current value is newer than the previous value, false otherwise
 */
export function isLastModifiedNewer(currentValue: string, previousValue?: string | null) {
  if (!previousValue) return true;

  const currentTime = Date.parse(currentValue);
  const previousTime = Date.parse(previousValue);

  // If either date is invalid, fall back to string comparison
  if (Number.isNaN(currentTime) || Number.isNaN(previousTime)) {
    return currentValue !== previousValue;
  }

  return currentTime > previousTime;
}
